<template>
  <div class="home-page-container">
    <el-radio-group v-model="activeType" class="tab_box">
      <el-radio-button :label='1'>油品明细</el-radio-button>
      <el-radio-button :label="2" v-if="showPos">POS明细</el-radio-button>
      <el-radio-button :label="3" v-if="hasUnOil">非油品明细</el-radio-button>
      <el-radio-button :label="4">会员卡明细</el-radio-button>
    </el-radio-group>
    <dailyBillDetail v-if="activeType === 1" />
    <posDailyBillDetail v-else-if="activeType === 2" />
    <unoilDailyBillDetail v-else-if="activeType === 3" />
    <vipDailyBillDetail v-else-if="activeType === 4" />
  </div>
</template>
<script>
import dailyBillDetail from './dailyBillDetail'
import posDailyBillDetail from './posDailyBillDetail'
import unoilDailyBillDetail from './unoilDailyBillDetail'
import vipDailyBillDetail from './vipDailyBillDetail'
import { getHasUnOil } from '@/api/finance/nonOil'
import { getHasPosRightInHistory } from '@/api/finance'

  export default {
    data () {
      return {
        tabList: [],
        activeType: 1,
        showPos: false,
        hasUnOil: false
      }
    },
    components: { dailyBillDetail, posDailyBillDetail, unoilDailyBillDetail, vipDailyBillDetail },
    created () {
      this.getHasPosRightInHistoryApi()
      this.checkUnOil()
    },
    methods: {
      // 判断是否存在pos
      async getHasPosRightInHistoryApi() {
        try {
          const { code, result } = await getHasPosRightInHistory()
          if(code !== 200) return
          this.showPos = result
        } catch (e) {
          console.log(e)
        }
      },
      // 是否非油权限
      async checkUnOil () {
        let { code, result } = await getHasUnOil()
        if (code !== 200) return
        this.hasUnOil = result
      },
    }
  }
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
  /deep/ .tab_box {
    margin-top: 20px;
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      background: #4B7EFE;
    }
  }
}
</style>